import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center w-full px-3 py-2 cursor-pointer sm:w-1/2 hover:bg-gray-100" }
const _hoisted_2 = { class: "flex-grow" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-primary" }
const _hoisted_5 = { class: "ml-5 text-sm text-gray-500" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { key: 0 }

import { Scorecard } from '@/typings/scorecard';
import { User } from '@/typings/user';
import { computed, toRefs } from 'vue';
import UserVue from '@/components/User/User.vue';
import Image from '@/components/Scorecard/Image.vue';

interface Props {
  scorecard: Scorecard;
  score: number;
  user?: User;
  showUserName?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    scorecard: null,
    score: null,
    user: null,
    showUserName: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  scorecard: Scorecard;
  score: number;
  user?: User;
  showUserName?: boolean;
}



const { scorecard } = toRefs(props);

const year = computed(() => new Date(scorecard.value.LocksAt).getFullYear());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Image, {
      class: "flex-shrink w-32 mr-5 min-w-32",
      scorecard: _unref(scorecard)
    }, null, 8, ["scorecard"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(scorecard).Title), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(year)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!__props.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : (_openBlock(), _createBlock(UserVue, {
              key: 1,
              user: __props.user
            }, null, 8, ["user"])),
        _createElementVNode("span", null, _toDisplayString(__props.score), 1)
      ])
    ])
  ]))
}
}

})